import request from '@/axios'

const BLUETOOTH_BADGE_PREFIX = '/inside/bluetooth/badge'

// ************************************蓝牙（绑定、解绑 逻辑）********************************************
// 蓝牙连接前校验
export const checkBluetoothBadgeConnect = (data) => {
  return request({
    url: `${BLUETOOTH_BADGE_PREFIX}/connect/check`,
    data
  })
}

// 绑定当前员工与设备
export const bindBluetoothBadge = (data) => {
  return request({
    url: `${BLUETOOTH_BADGE_PREFIX}/bind`,
    data
  })
}

// 查询当前员工绑定详情
export const getBluetoothBadgeBindingDetail = (data) => {
  return request({
    url: `${BLUETOOTH_BADGE_PREFIX}/binding/detail`,
    data
  })
}

// 当前员工解除绑定
export const unbindBluetoothBadge = (data) => {
  return request({
    url: `${BLUETOOTH_BADGE_PREFIX}/unbind`,
    data
  })
}
// 上报设备硬件状态
export const reportBluetoothBadgeStatus = (data) => {
  return request({
    url: `${BLUETOOTH_BADGE_PREFIX}/status/report`,
    data
  })
}

// ************************************蓝牙（文件处理逻辑）********************************************
// 保存蓝牙录音
export const saveBluetoothBadgeRecord = (data) => {
  return request({
    url: '/inside/badge/bluetooth/record/save',
    data
  })
}

// 查询待分析蓝牙录音列表
export const getBluetoothBadgeRecordList = (data) => {
  return request({
    // url: '/inside/badge/record/list',
    url: '/inside/badge/bluetooth/record/list',
    data
  })
}

// 作废蓝牙录音
export const voidBluetoothBadgeRecord = (data) => {
  return request({
    url: '/inside/badge/bluetooth/record/void',
    data
  })
}

// 分析蓝牙录音
export const analyzeBluetoothBadgeRecord = (data) => {
  return request({
    url: '/inside/bluetooth/badge/record/analyze',
    data
  })
}

// ************************************web设备管理逻辑********************************************
// 查询蓝牙卡片数据源管理列表
export const getBluetoothBadgeManageList = (data) => {
  return request({
    url: `${BLUETOOTH_BADGE_PREFIX}/manage/list`,
    data
  })
}

// 管理员解除员工绑定
export const unbindBluetoothBadgeByAdmin = (data) => {
  return request({
    url: `${BLUETOOTH_BADGE_PREFIX}/manage/unbind`,
    data
  })
}
